// SHA-256 helpers using SubtleCrypto. Returns hex strings for compactness in
// cache keys and recipe IDs.

const encoder = new TextEncoder();

export async function sha256Hex(input: string | ArrayBuffer): Promise<string> {
  const bytes =
    typeof input === 'string' ? encoder.encode(input) : new Uint8Array(input);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return bytesToHex(new Uint8Array(digest));
}

export async function sha256Bytes(
  input: string | ArrayBuffer,
): Promise<Uint8Array> {
  const bytes =
    typeof input === 'string' ? encoder.encode(input) : new Uint8Array(input);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return new Uint8Array(digest);
}

function bytesToHex(bytes: Uint8Array): string {
  let out = '';
  for (let i = 0; i < bytes.length; i++) {
    const b = bytes[i] as number;
    out += b.toString(16).padStart(2, '0');
  }
  return out;
}
